/* Ingle Home: progressive homepage motion. */
(() => {
  const main = document.querySelector('.template-index .main-content');
  if (!main) return;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observers = new Map();
  const header = document.querySelector('.site-header');
  const updateOffset = () => document.documentElement.style.setProperty('--ingle-header-offset', `${header ? Math.ceil(header.getBoundingClientRect().height) + 16 : 16}px`);
  updateOffset();
  if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
  else window.addEventListener('resize', updateOffset, { passive: true });
  const show = (el) => el.classList.add('is-in-view');

  function clear(section) {
    const observer = observers.get(section);
    if (observer) observer.disconnect();
    observers.delete(section);
    section.querySelectorAll('.ingle-reveal').forEach((el) => el.classList.remove('ingle-reveal', 'is-in-view'));
  }
  function init(section) {
    clear(section);
    if (section === main.querySelector('.shopify-section') || motion.matches || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) return;
    const candidates = Array.from(section.querySelectorAll('h2, .grid__item'));
    const targets = candidates.filter((el) => !candidates.some((parent) => parent !== el && parent.contains(el)));
    if (!targets.length) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
    observers.set(section, observer);
    targets.forEach((el) => {
      if (el.getBoundingClientRect().top < window.innerHeight || el.contains(document.activeElement)) return;
      el.classList.add('ingle-reveal');
      observer.observe(el);
    });
  }
  const refresh = () => main.querySelectorAll('.shopify-section').forEach(init);
  main.addEventListener('focusin', (event) => {
    const target = event.target.closest('.ingle-reveal');
    if (target) show(target);
  });
  document.addEventListener('shopify:section:load', (event) => { if (main.contains(event.target)) init(event.target); });
  document.addEventListener('shopify:section:unload', (event) => clear(event.target));
  if (motion.addEventListener) motion.addEventListener('change', refresh);
  else motion.addListener(refresh);
  refresh();
})();
